import ListSearchBar from "../components/ListSearchBar";
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Dropdown, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import ReactPaginate from "react-paginate";
import { useTranslate } from "../hooks/LanguageProvider";
import LineChartComponent from "../components/Charts/Gpsactivity";
import { PropagateLoader } from "react-spinners";
import ExcelJS from "exceljs";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/fr";
import { Link, useNavigate } from "react-router-dom";

import {
  engineStat,
  BarreReseau,
  ValidatePosition,
  getAddressFromCoordinates,
  GetAddressesFromCoords,
  formatDateForAlgeriaTimeZone,
  formatDateInServerUtc,
  useClipboard,
  toTimestamp,
  BarreSpeed,
  addHiddenColumn,
  removeHiddenColumn,
  getHiddenColumns,
} from "../utilities/functions";
import MapDrawer from "../components/Map/MapDrawer";
import { usePagePreferences } from "../hooks/usePagePreferences";
import "../assets/css/fleet-activity.css";

const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
const PAGE_ID = 4; // ✅ Fleet page id_permission/id_page

export function Fleet() {
  interface Vehicle {
    id: number;
    immatriculation_vehicule: string;
    psn_dispositif: string;
    id_puce: number | null;
    numero_puce: string | null;
    operateur_puce: string | null;
    nom_groupe: string;
    nom_user: string;
    prenom_user: string;
    nom_conducteur: string;
    prenom_conducteur: string;
    TIMESTAMP: string;
    GPSDIST: number;
    GSMLVL: number | null;
    NST: number;
    ENGINESTAT: number;
    LAT: number;
    LON: number;
    vehicule_type: string;
    telephone_conducteur: string;
    SOG: number;
    IB_CODE: string;
    state: number;
  }

  const navigate = useNavigate();
  const { translate } = useTranslate();

  const user_id = Number(localStorage.getItem("userid") || 0);
  const {
    preferences: listPreferences,
    setPreference: setListPreference,
    setPreferences: setListPreferences,
    loaded: listPreferencesLoaded,
  } = usePagePreferences("fleet", {
    limit: 10,
    page: 1,
    typeSearch: "Immatriculation",
    type: 0,
    search: "",
    column: "0",
    sort: "ASC",
  });

  const [list_Fleet, setItems] = useState<Vehicle[]>([]);
  let [total, setTotal] = useState(0);
  let [limit, setSelectedLimit] = useState(Number(listPreferences.limit) || 10);
  const [pageCount, setPageCount] = useState(0);
  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const [address, setAddress] = useState<string>("");
  const [loadingAddress, setLoadingAddress] = useState<boolean>(false);
  const [selectedHeader, setSelectedHeader] = useState("");
  const [loading, setLoading] = useState<boolean>(false);

  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  const [markerCoordinates, setMarkerCoordinates] = useState({ LAT: 0, LON: 0 });
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const fleetRequestIdRef = useRef(0);
  const [typeSearch, setTypeSearch] = useState(String(listPreferences.typeSearch || "Immatriculation"));
  const [selectedSearch, setSelectedSearch] = useState(translate("Immatriculation"));
  const [isFleetCompact, setIsFleetCompact] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  const [type, setType] = useState(Number(listPreferences.type) || 0);
  const [search, setSearch] = useState(String(listPreferences.search || ""));
  const [column, setSortColumn] = useState(String(listPreferences.column || "0"));
  const [sort, setSort] = useState(String(listPreferences.sort || "ASC"));
  const [page, setPage] = useState<number>(Number(listPreferences.page) || 1);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [selectedDelayPreset, setSelectedDelayPreset] = useState<string | null>(null);


  const handleDelayPreset = (presetKey: string, delayDate: Dayjs) => {
    setSelectedDelayPreset(presetKey);
    setStartDate(null);
    setEndDate(delayDate);
    setPage(1);

    setFilters((prev) => {
      const updated = {
        ...prev,
        dateFrom: null,
        dateTo: formatDateInServerUtc(delayDate.toISOString()),
      };

      getFleet(limit, 1, search, type, column, sort, updated);
      return updated;
    });
  };

  const { copyToClipboard, copiedId } = useClipboard(translate("Matriculation Copied"));

  useEffect(() => {
    const updateFleetCompact = () => setIsFleetCompact(window.innerWidth < 768);

    updateFleetCompact();
    window.addEventListener("resize", updateFleetCompact);

    return () => window.removeEventListener("resize", updateFleetCompact);
  }, []);

  /********************** columns **********************/
  const columns = [
    { key: "immatriculation_vehicule", label: translate("Matriculation") },
    { key: "psn_dispositif", label: translate("PSN") },
    { key: "nom_groupe", label: translate("Vehicles Groups") },
    { key: "nom_user", label: translate("User") },
    { key: "nom_conducteur", label: translate("Driver") },
    { key: "TIMESTAMP", label: translate("Date Time") },
    { key: "GPSDIST", label: translate("Distance") },
    { key: "GSMLVL", label: translate("GSM") },
    { key: "SOG", label: translate("Speed") },
  ] as const;

  type ColumnKey = (typeof columns)[number]["key"];

  const defaultSelectedColumns = columns.reduce((acc, c) => {
    (acc as any)[c.key] = true;
    return acc;
  }, {} as Record<ColumnKey, boolean>);

  const [selectedColumns, setSelectedColumns] = useState<Record<ColumnKey, boolean>>(
    defaultSelectedColumns
  );

  // ✅ Load hidden columns from DB on page load
  useEffect(() => {
    (async () => {
      if (!user_id) return;
      try {
        const hidden = await getHiddenColumns(user_id, PAGE_ID); // ["psn_dispositif", ...]
        setSelectedColumns((prev) => {
          const next = { ...prev };
          columns.forEach((c) => {
            next[c.key] = !hidden.includes(c.key);
          });
          return next;
        });
      } catch (e) {
        console.error(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);

  // ✅ Save preference without redirect (stay on Fleet)
  const handleColumnChange = async (columnKey: ColumnKey) => {
    if (!user_id) return;

    const currentlyVisible = selectedColumns[columnKey];
    const nextVisible = !currentlyVisible;

    // update UI immediately
    setSelectedColumns((prev) => ({ ...prev, [columnKey]: nextVisible }));

    try {
      if (!nextVisible) {
        // HIDE => add row in preferences_columns
        await addHiddenColumn({
          id_user: user_id,
          id_page: PAGE_ID,
          column_name: columnKey,
        });
      } else {
        // SHOW => remove row
        await removeHiddenColumn({
          id_user: user_id,
          id_page: PAGE_ID,
          column_name: columnKey,
        });
      }
    } catch (err) {
      console.error(err);

      // rollback UI if API fails
      setSelectedColumns((prev) => ({ ...prev, [columnKey]: currentlyVisible }));
    }
  };


  /********************** filters types **********************/
  type mainFilter = {
    engineContact: boolean;
    lastTransmission: boolean;
    position: boolean;
    gsmNetwork: boolean;
    fullMemory: boolean;
    relayActive: boolean;
    [key: string]: boolean;
  };

  type Filters = {
    engineContact: string | null;
    lastTransmission: string | null;
    position: string | null;
    gsmNetwork: number | null;
    dateFrom: string | null;
    dateTo: string | null;
  };

  const [mainFilters, setMainFilters] = useState<mainFilter>({
    engineContact: false,
    lastTransmission: false,
    position: false,
    gsmNetwork: false,
    fullMemory: false,
    relayActive: false,
  });

  const [filters, setFilters] = useState<Filters>({
    engineContact: null,
    lastTransmission: null,
    position: null,
    gsmNetwork: null,
    dateFrom: null,
    dateTo: null,
  });

  const handleCheckboxChangeFilters = (filterName: keyof typeof mainFilters) => {
    setMainFilters((prevFilters) => {
      const updatedFilters = {
        ...prevFilters,
        [filterName]: !prevFilters[filterName],
      };

      if (!updatedFilters[filterName]) {
        setFilters((prevSelections) => ({
          ...prevSelections,
          [filterName]: null,
        }));
      }

      return updatedFilters;
    });
  };


  const handleRadioChange = (filterName: string, value: any) => {
    setFilters((prevSelections) => {
      const updatedFilters = {
        ...prevSelections,
        [filterName]: value,
      };


      getFleet(limit, page, search, type, column, sort, updatedFilters);


      console.log(updatedFilters);

      return updatedFilters;
    });
  };



  const [percentage, setPercentage] = useState(100);

  const handleSliderChange = (event: any) => {
    const newPercentage = event.target.value;
    setPercentage(newPercentage);
  };

  const handleSliderMouseUp = (event: any) => {
    const newPercentage = event.target.value;
    setPercentage(event.target.value);
    setFilters((prevSelections) => {
      const updatedFilters = {
        ...prevSelections,
        gsmNetwork: parseFloat(newPercentage),
      };


      getFleet(limit, page, search, type, column, sort, updatedFilters);


      console.log(updatedFilters);

      return updatedFilters;
    });
  };

  // Réinitialiser tous les filtres
  const handleResetFilters = () => {
    setMainFilters({
      engineContact: false,
      lastTransmission: false,
      position: false,
      gsmNetwork: false,
      fullMemory: false,
      relayActive: false,
    });

    setFilters({
      engineContact: null,
      lastTransmission: null,
      position: null,
      gsmNetwork: null,
      dateFrom: null,
      dateTo: null,
    });

    setStartDate(null);
    setEndDate(null);
    setSelectedDelayPreset(null);
    setPercentage(100);

    getFleet(limit, 1, search, type, column, sort, {
      engineContact: null,
      lastTransmission: null,
      position: null,
      gsmNetwork: null,
      dateFrom: null,
      dateTo: null,
    });
  };


  /********************** API fetch **********************/
  const getFleet = async (
    limit: number,
    page: number,
    search: string,
    type: number,
    column: string,
    sort: string,
    filters: Filters,
    showLoader: boolean = true
  ) => {
    const requestId = ++fleetRequestIdRef.current;
    const bodyData = JSON.stringify({
      limit,
      page,
      search,
      type,
      id_user: user_id,
      column,
      sort,
      filters,
    });

    try {
      if (showLoader) setLoading(true);

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: bodyData,
        mode: "cors" as RequestMode,
      };
      const [totalResponse, vehicleResponse] = await Promise.all([
        fetch(`${backendUrl}/api/fleet/totalpage`, requestOptions),
        fetch(`${backendUrl}/api/fleet/search`, requestOptions),
      ]);

      if (!totalResponse.ok || !vehicleResponse.ok) {
        throw new Error("Error retrieving fleet data");
      }

      const [totalPages, data] = await Promise.all([
        totalResponse.json(),
        vehicleResponse.json(),
      ]);

      // Ignore responses belonging to an older search value.
      if (requestId !== fleetRequestIdRef.current) return;

      const nextTotal = Number(totalPages?.[0]?.total ?? 0);
      setTotal(nextTotal);
      setPageCount(Math.ceil(nextTotal / limit));
      setItems(data);
      return data;
    } catch (error) {
      console.error("Error retrieving data from table", error);
    } finally {
      if (showLoader && requestId === fleetRequestIdRef.current) setLoading(false);
    }
  };

  useEffect(() => {
    if (!user_id || !listPreferencesLoaded) return;
    const nextLimit = Number(listPreferences.limit) || 10;
    const nextPage = Number(listPreferences.page) || 1;
    const nextSearch = String(listPreferences.search || "");
    const nextType = Number(listPreferences.type) || 0;
    const nextTypeSearch = String(listPreferences.typeSearch || "Immatriculation");
    const nextColumn = String(listPreferences.column || "0");
    const nextSort = String(listPreferences.sort || "ASC");

    setSelectedLimit(nextLimit);
    setPage(nextPage);
    setSearch(nextSearch);
    setType(nextType);
    setTypeSearch(nextTypeSearch);
    setSortColumn(nextColumn);
    setSort(nextSort);
    getFleet(nextLimit, nextPage, nextSearch, nextType, nextColumn, nextSort, filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id, listPreferencesLoaded]);

  /********************** UI handlers **********************/
  const handleRowClick = async (rowId: string, lat: number, lon: number) => {
    const isOpening = expandedRow !== rowId;
    setExpandedRow(isOpening ? rowId : null);
    if (isOpening) setSelectedHeader("gpsActivity");

    if (isOpening) {
      try {
        setLoadingAddress(true);
        const addr = await getAddressFromCoordinates(lat, lon);
        setAddress(addr);
      } catch (error) {
        console.error("Error fetching address:", error);
      } finally {
        setLoadingAddress(false);
      }
    }
  };

  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    const nextLimit = parseInt(newValue, 10);
    setPage(1);
    setSelectedLimit(nextLimit);
    setListPreferences({ limit: nextLimit, page: 1 });
    const commentsFormServer = await getFleet(nextLimit, 1, search, type, column, sort, filters);
    setItems(commentsFormServer || []);
    window.scrollTo(0, 0);
  };

  const handlePageClick = async (data: any) => {
    let pg = data.selected + 1;
    await getFleet(limit, pg, search, type, column, sort, filters);
    setPage(pg);
    setListPreference("page", pg);
    window.scrollTo(0, 0);
  };

  // click outside dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        // no-op
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // excel selection
  const handleCheckboxChange = (index: number, isChecked: boolean) => {
    const newSelectedRows = new Set(selectedRows);
    if (isChecked) newSelectedRows.add(index);
    else newSelectedRows.delete(index);
    setSelectedRows(newSelectedRows);
  };

  const handleSelectAllCheckboxChange = (isChecked: boolean) => {
    setSelectAllChecked(isChecked);
    const newSelectedRows = new Set<number>();
    if (isChecked) list_Fleet.forEach((_, index) => newSelectedRows.add(index));
    setSelectedRows(newSelectedRows);
  };

  async function exportToExcel() {
    const selectedData = list_Fleet.filter((_, index) => selectedRows.has(index));

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Fleet Data");

    const headers = [
      "Date Time",
      "Vehicle",
      "PSN",
      "Vehicles Groups",
      "User",
      "Driver",
      "Distance",
      "GSM",
      "State",
      "ENGINESTAT",
      "Speed",
      "Address",
    ];

    worksheet.addRow(headers);
    worksheet.getRow(1).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "DDDDDD" } };

    const locations = selectedData.map((item) => ({ id: item.id, lat: item.LAT, lon: item.LON }));
    const addresses = await GetAddressesFromCoords(locations);

    for (let i = 0; i < selectedData.length; i++) {
      const item = selectedData[i];
      const addr = addresses[i]?.address ?? "";

      const engineState =
        item.ENGINESTAT === 0 ? "Engine off" :
          item.ENGINESTAT === 1 && item.SOG > 5 ? "Engine running" :
            item.ENGINESTAT === 1 ? "Engine on" : "Unknown";

      worksheet.addRow([
        formatDateForAlgeriaTimeZone(item.TIMESTAMP),
        item.immatriculation_vehicule,
        item.psn_dispositif,
        item.nom_groupe,
        `${item.nom_user} ${item.prenom_user}`,
        `${item.nom_conducteur} ${item.prenom_conducteur}`,
        `${Math.floor(item.GPSDIST / 1000)} km`,
        item.GSMLVL !== null ? Number(item.GSMLVL).toFixed(0) + "%" : "0",
        item.NST === 1 ? "Valid position" : "Invalid position",
        engineState,
        `${item.SOG}`,
        addr,
      ]);
    }

    worksheet.columns.forEach((col) => (col.width = Math.max(col.width ?? 0, 20)));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const currentDate = new Date();
    const dateString = currentDate.toISOString().split("T")[0];
    const timeString = currentDate.toTimeString().split(" ")[0].replace(/:/g, "-");
    const fileName = `fleet_Repport_${dateString}_${timeString}.xlsx`;

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    handleSelectAllCheckboxChange(false);
  }

  const handleMapIconClick = (LAT: number, LON: number, vehicle: Vehicle) => {
    setMarkerCoordinates({ LAT, LON });
    setSelectedVehicle(vehicle);
    setShowMapModal(true);
  };

  const menuItems = [
    translate("Matriculation"),
    translate("PSN"),
    translate("Vehicles Groups"),
    translate("User"),
    translate("Driver"),
    translate("GPSDIST"),
    translate("GSMLVL"),
    translate("SOG"),
  ];

  const handleTypeSearch = (selectedValue: string) => {
    let nextType = type;
    switch (selectedValue) {
      case translate("Matriculation"):
        setSelectedSearch(translate("Matriculation"));
        nextType = 0;
        setType(nextType);
        break;
      case translate("PSN"):
        setSelectedSearch(translate("PSN"));
        nextType = 1;
        setType(nextType);
        break;
      case translate("Vehicles Groups"):
        setSelectedSearch(translate("Vehicles Groups"));
        nextType = 2;
        setType(nextType);
        break;
      case translate("User"):
        setSelectedSearch(translate("User"));
        nextType = 3;
        setType(nextType);
        break;
      case translate("Driver"):
        setSelectedSearch(translate("Driver"));
        nextType = 4;
        setType(nextType);
        break;
      default:
        break;
    }
    setTypeSearch(translate(selectedValue));
    setPage(1);
    setListPreferences({ type: nextType, typeSearch: selectedValue, page: 1 });
    getFleet(limit, 1, search, nextType, column, sort, filters);
  };

  const handleAdvancedSearch = async (event: any) => {
    const newValue = event.target.value;
    setSearch(newValue);
    setPage(1);
    setListPreferences({ search: newValue, page: 1 });
    await getFleet(limit, 1, newValue, type, column, sort, filters);
  };

  const handleResetSearch = async () => {
    setSearch("");
    setPage(1);
    setListPreferences({ search: "", page: 1 });
    await getFleet(limit, 1, "", type, column, sort, filters);
  };

  const handleSortingColum = (currentColumn: string) => {
    const nextSort = sort === "DESC" ? "ASC" : "DESC";
    setSort(nextSort);
    setSortColumn(currentColumn);
    setPage(1);
    setListPreferences({ sort: nextSort, column: currentColumn, page: 1 });
    getFleet(limit, 1, search, type, currentColumn, nextSort, filters);
  };

  // refresh
  useEffect(() => {
    const refreshInterval = setInterval(() => {
      getFleet(limit, page, search, type, column, sort, filters, false);
    }, 15000);

    return () => clearInterval(refreshInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, page, search, type, column, sort, filters]);

  const handleStartDateChange = (newDate: Dayjs | null) => {
    setStartDate(newDate);
    setFilters((prev) => {
      const updated = {
        ...prev,
        dateFrom: newDate ? formatDateInServerUtc(newDate.toISOString()) : null,
      };
      getFleet(limit, page, search, type, column, sort, updated);
      return updated;
    });
  };

  const handleEndDateChange = (newDate: Dayjs | null) => {
    setEndDate(newDate);
    setFilters((prev) => {
      const updated = {
        ...prev,
        dateTo: newDate ? formatDateInServerUtc(newDate.toISOString()) : null,
      };
      getFleet(limit, page, search, type, column, sort, updated);
      return updated;
    });
  };

  /********************** RENDER **********************/
  return (
    <>
      <div className="row">
        <div className="col-sm-6 col-md-6 d-flex">
          <h4>
            <i className="fa fa-light fa-chart-line"></i>{" "}
            {translate("Fleet view")} ({total})
          </h4>
        </div>

        <div className="float-right col-sm-6 col-md-6">
          <div style={isFleetCompact ? { padding: "0 10px 12px" } : undefined}>
            <button
              className="btn btn-outline-info btn-generate-csv float-right"
              onClick={exportToExcel}
              disabled={selectedRows.size === 0}
              style={{
                marginBottom: isFleetCompact ? 0 : "12px",
                width: isFleetCompact ? "100%" : undefined,
                float: isFleetCompact ? "none" : undefined,
              }}
            >
              <i className="las la-file-alt mr-3"></i>
              {translate("Export")}
            </button>
          </div>
        </div>
      </div>

      <div
        className={isFleetCompact ? "" : "row"}
        style={
          isFleetCompact
            ? {
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr) 58px 28px",
              columnGap: "8px",
              alignItems: "center",
              marginLeft: 0,
              marginRight: 0,
              padding: "10px 10px 12px 0",
            }
            : { marginLeft: 0, marginRight: 0 }
        }
      >
        <div
          className={isFleetCompact ? "" : "col-md-6 list-search-column"}
          style={
            isFleetCompact
              ? { minWidth: 0, margin: 0, padding: 0 }
              : { margin: "0px 0px 10px 0px", padding: "10px" }
          }
        >
          <ListSearchBar criteria={<Dropdown style={isFleetCompact ? { margin: 0 } : undefined}>
              <Dropdown.Toggle
                variant="link"
                id="dropdown-custom"
                className="custom-toggle"
                style={isFleetCompact ? { height: "38px", minWidth: "36px", width: "36px", padding: 0 } : undefined}
              >{translate(typeSearch)}</Dropdown.Toggle>
              <Dropdown.Menu>
                {menuItems.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => handleTypeSearch(item)}
                    eventKey={item}
                    active={typeSearch === item}
                    className={typeSearch === item ? "select-active" : ""}
                  >
                    {item}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>} onReset={handleResetSearch} resetLabel={translate("Reset search")}>
<input
              type="text"
              placeholder={` ${translate("Search by")} ${translate(typeSearch)}`}
              value={search}
              onChange={handleAdvancedSearch}
              className="form-control"
              style={{
                flex: "1 1 auto",
                minWidth: 0,
                height: isFleetCompact ? "38px" : undefined,
                fontSize: isFleetCompact ? "13px" : undefined,
                paddingLeft: isFleetCompact ? "8px" : undefined,
                paddingRight: isFleetCompact ? "8px" : undefined,
              }}
            />
</ListSearchBar>
        </div>
        <div
          className={
            isFleetCompact
              ? "d-flex justify-content-start align-items-center"
              : "col-md-8 d-flex justify-content-end align-items-center"
          }
          style={
            isFleetCompact
              ? { display: "contents" }
              : undefined
          }
        >

          <button
            className="btn position-fixed end-0 z-3 d-none d-md-inline-flex"
            style={{
              top: '30%',
              background: "#ff7e41",
              border: '2px solid #ff7e41',
              color: 'white',
              fontSize: '16px',
              transition: 'all 0.3s ease',
            }}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#drawerMenu"
            aria-controls="drawerMenu"
          >
            <i className="las la-filter" style={{ fontSize: "24px" }}></i>
          </button>

          <div
            className="offcanvas offcanvas-end"
            tabIndex={-1}
            id="drawerMenu"
            aria-labelledby="drawerMenuLabel"
            style={{ width: "480px", display: isFleetCompact ? "none" : undefined }}
          >
            <div className="d-flex justify-content-between align-items-start p-4 border-bottom border-1  position-relative"
              style={{
                cursor: 'pointer',
                padding: '12px 16px',
                borderRadius: '0px',
                borderBottom: '2px solid #f0f0f0 !important',
                background: 'linear-gradient(135deg, #ff7e41 0%, #e76f33 100%)',
              }}
            >
              <div>
                <h6 className="mb-1 fw-bold text-white">{translate('advancedSearch')}</h6>
                <p className="mb-0 text-white small" style={{ opacity: 0.9 }}>{translate('refineSearch')}</p>
              </div>

              {/* Close */}
              <button
                type="button"
                className="btn   d-flex align-items-center text-white"
                data-bs-dismiss="offcanvas"
                style={{ fontSize: "24px" }}
                aria-label="Close"
              >
                <i className="las la-times"></i>
              </button>
            </div>

            <div className="offcanvas-body" style={{ padding: "20px", background: "#fafafa" }}>
              {/* Reset Button */}
              <button
                type="button"
                className="btn btn-outline-danger w-100 mb-4"
                onClick={handleResetFilters}
                style={{
                  padding: "8px 12px",
                  fontSize: "14px",
                  fontWeight: "500",
                  border: "2px solid #dc3545",
                }}
              >
                <i className="las la-redo" style={{ marginRight: "8px" }}></i>
                {translate("Réinitialiser les filtres")}
              </button>
              {/* Engine Contact */}
              <div className="mb-4" style={{ background: "white", padding: "12px", borderRadius: "8px", border: "1px solid #e0e0e0" }}>
                <label className="d-flex align-items-center" style={{ cursor: "pointer", marginBottom: "0" }} onChange={() => handleCheckboxChangeFilters("engineContact")}>
                  <input
                    type="checkbox"
                    name="engineContact"
                    checked={mainFilters.engineContact}
                    onChange={() => { }}
                    style={{ display: "none" }}
                  />
                  <i className="las la-cogs" style={{ color: "#ff7e41", fontSize: "20px", marginRight: "12px" }}></i>
                  <span style={{ fontWeight: mainFilters.engineContact ? "600" : "500", fontSize: "14px", color: "#333" }}>
                    {translate('contactMotor')}
                  </span>
                </label>
                {mainFilters.engineContact && (
                  <div style={{ display: 'flex', flexDirection: 'column', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e0e0e0' }}>
                    <label style={{ marginBottom: "8px", fontSize: "13px", color: "#666" }}>
                      <input
                        type="radio"
                        name="engineContact"
                        value="off"
                        onChange={() => handleRadioChange('engineContact', 'off')}
                        checked={filters.engineContact === 'off'}
                      />
                      <span style={{ marginLeft: "6px" }}>{translate('stop')}</span>
                    </label>
                    <label style={{ fontSize: "13px", color: "#666" }}>
                      <input
                        type="radio"
                        name="engineContact"
                        value="on"
                        onChange={() => handleRadioChange('engineContact', 'on')}
                        checked={filters.engineContact === 'on'}
                      />
                      <span style={{ marginLeft: "6px" }}>{translate('running')}</span>
                    </label>
                  </div>
                )}
              </div>

              {/* Last Transmission */}
              <div className="mb-4" style={{ background: "white", padding: "12px", borderRadius: "8px", border: "1px solid #e0e0e0" }}>
                <label className="d-flex align-items-center" style={{ cursor: "pointer", marginBottom: "0" }} onChange={() => handleCheckboxChangeFilters("lastTransmission")}>
                  <input
                    type="checkbox"
                    name="lastTransmission"
                    checked={mainFilters.lastTransmission}
                    onChange={() => { }}
                    style={{ display: "none" }}
                  />
                  <i className="las la-sync-alt" style={{ color: "#ff7e41", fontSize: "20px", marginRight: "12px" }}></i>
                  <span style={{ fontWeight: mainFilters.lastTransmission ? "600" : "500", fontSize: "14px", color: "#333" }}>
                    {translate('lastTransmission')}
                  </span>
                </label>
                {mainFilters.lastTransmission && (
                  <div style={{ display: 'flex', flexDirection: 'column', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e0e0e0' }}>
                    <label style={{ marginBottom: "8px", fontSize: "13px", color: "#666" }}>
                      <input
                        type="radio"
                        name="lastTransmission"
                        value="last_1h"
                        onChange={() => handleRadioChange('lastTransmission', 'last_1h')}
                        checked={filters.lastTransmission === 'last_1h'}
                      />
                      <span style={{ marginLeft: "6px" }}>{translate('last1Hour')}</span>
                    </label>
                    <label style={{ marginBottom: "8px", fontSize: "13px", color: "#666" }}>
                      <input
                        type="radio"
                        name="lastTransmission"
                        value="last_24h"
                        onChange={() => handleRadioChange('lastTransmission', 'last_24h')}
                        checked={filters.lastTransmission === 'last_24h'}
                      />
                      <span style={{ marginLeft: "6px" }}>{translate('last24Hours')}</span>
                    </label>
                    <label style={{ marginBottom: "8px", fontSize: "13px", color: "#666" }}>
                      <input
                        type="radio"
                        name="lastTransmission"
                        value="last_7d"
                        onChange={() => handleRadioChange('lastTransmission', 'last_7d')}
                        checked={filters.lastTransmission === 'last_7d'}
                      />
                      <span style={{ marginLeft: "6px" }}>{translate('last7Days')}</span>
                    </label>
                    <label style={{ fontSize: "13px", color: "#666" }}>
                      <input
                        type="radio"
                        name="lastTransmission"
                        value="present_month"
                        onChange={() => handleRadioChange('lastTransmission', 'present_month')}
                        checked={filters.lastTransmission === 'present_month'}
                      />
                      <span style={{ marginLeft: "6px" }}>{translate('currentMonth')}</span>
                    </label>
                  </div>
                )}
              </div>

              {/* Position */}
              <div className="mb-4" style={{ background: "white", padding: "12px", borderRadius: "8px", border: "1px solid #e0e0e0" }}>
                <label className="d-flex align-items-center" style={{ cursor: "pointer", marginBottom: "0" }} onChange={() => handleCheckboxChangeFilters("position")}>
                  <input
                    type="checkbox"
                    name="positionStatus"
                    checked={mainFilters.position}
                    onChange={() => { }}
                    style={{ display: "none" }}
                  />
                  <i className="las la-map-marker-alt" style={{ color: "#ff7e41", fontSize: "20px", marginRight: "12px" }}></i>
                  <span style={{ fontWeight: mainFilters.position ? "600" : "500", fontSize: "14px", color: "#333" }}>
                    {translate('position')}
                  </span>
                </label>
                {mainFilters.position && (
                  <div style={{ display: 'flex', flexDirection: 'column', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e0e0e0' }}>
                    <label style={{ marginBottom: "8px", fontSize: "13px", color: "#666" }}>
                      <input
                        type="radio"
                        name="positionStatus"
                        value="invalid"
                        onChange={() => handleRadioChange('position', 'invalid')}
                        checked={filters.position === 'invalid'}
                      />
                      <span style={{ marginLeft: "6px" }}>{translate('invalid')}</span>
                    </label>
                    <label style={{ fontSize: "13px", color: "#666" }}>
                      <input
                        type="radio"
                        name="positionStatus"
                        value="valid"
                        onChange={() => handleRadioChange('position', 'valid')}
                        checked={filters.position === 'valid'}
                      />
                      <span style={{ marginLeft: "6px" }}>{translate('valid')}</span>
                    </label>
                  </div>
                )}
              </div>

              {/* GSM Network */}
              <div className="mb-4" style={{ background: "white", padding: "12px", borderRadius: "8px", border: "1px solid #e0e0e0" }}>
                <label className="d-flex align-items-center" style={{ cursor: "pointer", marginBottom: "0" }} onChange={() => handleCheckboxChangeFilters("gsmNetwork")}>
                  <input
                    type="checkbox"
                    name="gsmNetwork"
                    checked={mainFilters.gsmNetwork}
                    onChange={() => { }}
                    style={{ display: "none" }}
                  />
                  <i className="las la-signal" style={{ color: "#ff7e41", fontSize: "20px", marginRight: "12px" }}></i>
                  <span style={{ fontWeight: mainFilters.gsmNetwork ? "600" : "500", fontSize: "14px", color: "#333" }}>
                    {translate('gsmNetwork')}
                  </span>
                </label>
                {mainFilters.gsmNetwork && (
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e0e0e0' }}>
                    <input
                      type="range"
                      id="percentageSlider"
                      min="0"
                      max="100"
                      value={percentage}
                      onChange={handleSliderChange}
                      onMouseUp={handleSliderMouseUp}
                      style={{ margin: '0', width: '70%', marginRight: '10px' }}
                    />
                    <span style={{ fontSize: "13px", fontWeight: "600", color: "#ff7e41", minWidth: "45px" }}>{percentage}%</span>
                  </div>
                )}
              </div>


              {/* Dates Filter Section */}
              <div style={{ background: "white", padding: "12px", borderRadius: "8px", border: "1px solid #e0e0e0", marginBottom: "20px" }}>
                <h5 style={{ fontSize: "14px", fontWeight: "600", color: "#333", marginBottom: "16px", display: "flex", alignItems: "center" }}>
                  <i className="las la-calendar" style={{ marginRight: "8px", color: "#ff7e41", fontSize: "18px" }}></i>
                  {translate("Filter by date:")}
                </h5>

                <div style={{ marginBottom: "16px" }}>
                  <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", fontSize: "13px", color: "#555" }}>
                    {translate("Retard de transmission")}
                  </label>

                  <div className="d-flex flex-wrap gap-2">
                    <button
                      type="button"
                      className={`btn btn-sm ${selectedDelayPreset === "delay_1h" ? "btn-danger" : "btn-outline-danger"}`}
                      onClick={() => handleDelayPreset("delay_1h", dayjs().subtract(1, "hour"))}
                    >
                      1 heure
                    </button>

                    <button
                      type="button"
                      className={`btn btn-sm ${selectedDelayPreset === "delay_24h" ? "btn-danger" : "btn-outline-danger"}`}
                      onClick={() => handleDelayPreset("delay_24h", dayjs().subtract(24, "hour"))}
                    >
                      24 heures
                    </button>

                    <button
                      type="button"
                      className={`btn btn-sm ${selectedDelayPreset === "delay_2d" ? "btn-danger" : "btn-outline-danger"}`}
                      onClick={() => handleDelayPreset("delay_2d", dayjs().subtract(2, "day"))}
                    >
                      2 jours
                    </button>

                    <button
                      type="button"
                      className={`btn btn-sm ${selectedDelayPreset === "delay_7d" ? "btn-danger" : "btn-outline-danger"}`}
                      onClick={() => handleDelayPreset("delay_7d", dayjs().subtract(7, "day"))}
                    >
                      1 semaine
                    </button>
                  </div>
                </div>

                {/* Date From */}
                <div style={{ marginBottom: "16px" }}>
                  <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", fontSize: "13px", color: "#555" }}>
                    📅 {translate("À partir du")} <span style={{ color: "#999", fontSize: "12px" }}>(optionnel)</span>
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                    <DateTimePicker
                      value={startDate}
                      onChange={handleStartDateChange}
                      ampm={false}
                      format="YYYY-MM-DD HH:mm:ss"
                      maxDate={endDate || dayjs()}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: {
                            "& .MuiOutlinedInput-root": {
                              height: 40,
                              fontSize: "14px",
                              borderRadius: "6px",
                              "& fieldset": { borderColor: "#ddd" },
                              "&:hover fieldset": { borderColor: "#e76f33" },
                              "&.Mui-focused fieldset": { borderColor: "#d95c1e", borderWidth: "2px" },
                            },
                            "& .MuiInputLabel-root": {
                              color: "#ff7e41",
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: "#d95c1e",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>

                {/* Date To */}
                <div>
                  <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", fontSize: "13px", color: "#555" }}>
                    📅 {translate("Jusqu'au")} <span style={{ color: "#999", fontSize: "12px" }}>(optionnel)</span>
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                    <DateTimePicker
                      value={endDate}
                      onChange={handleEndDateChange}
                      ampm={false}
                      format="YYYY-MM-DD HH:mm:ss"
                      minDate={startDate || undefined}
                      maxDate={dayjs()}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          sx: {
                            "& .MuiOutlinedInput-root": {
                              height: 40,
                              fontSize: "14px",
                              borderRadius: "6px",
                              "& fieldset": { borderColor: "#ddd" },
                              "&:hover fieldset": { borderColor: "#e76f33" },
                              "&.Mui-focused fieldset": { borderColor: "#d95c1e", borderWidth: "2px" },
                            },
                            "& .MuiInputLabel-root": {
                              color: "#ff7e41",
                            },
                            "& .MuiInputLabel-root.Mui-focused": {
                              color: "#d95c1e",
                            },
                          },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          </div>

          <label
            className={isFleetCompact ? "mb-0 d-inline-flex align-items-center" : "ml-auto"}
            style={isFleetCompact ? { flex: "0 0 auto", justifySelf: "start", margin: 0, width: "58px" } : undefined}
          >
            {translate("Show")}
            <select
              name={isFleetCompact ? "Fleet_Table_0_length" : "DataTables_Table_0_length"}
              aria-controls="DataTables_Table_0"
              className="custom-select custom-select-sm form-control form-control-sm mr-2 ml-2"
              style={{
                width: isFleetCompact ? "58px" : "66px",
                height: isFleetCompact ? "38px" : undefined,
                paddingLeft: isFleetCompact ? "6px" : undefined,
                paddingRight: isFleetCompact ? "18px" : undefined,
                marginLeft: isFleetCompact ? 0 : undefined,
                marginRight: isFleetCompact ? 0 : undefined,
              }}
              value={limit}
              onChange={handleSelectChange}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </select>
          </label>

          <button
            className="btn d-none d-md-inline-flex"
            style={{

              background: "none",
            }}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#drawerMenu"
            aria-controls="drawerMenu"
          >
            <i className="las la-filter" style={{ fontSize: "24px" }}></i>
          </button>

          <Dropdown style={isFleetCompact ? { width: "28px", justifySelf: "start", margin: 0 } : undefined}>
            <Dropdown.Toggle
              variant=""
              id="dropdown-basic"
              title={translate("Display columns")}
              style={isFleetCompact ? { width: "28px", minWidth: "28px", height: "38px", padding: 0 } : undefined}
            >
              <i className="las la-eye"></i>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {columns.map((c) => (
                <Dropdown.Item
                  key={c.key}
                  as="button"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedColumns[c.key]}
                    onChange={() => handleColumnChange(c.key)}
                  />
                  <span style={{ marginLeft: "10px" }}>{c.label}</span>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <Button
            variant="outline-primary"
            className="ml-2 d-none d-md-inline-flex"
            onClick={() => navigate(`/preference?focusPage=${PAGE_ID}`)}
            title={translate("Preferences")}
          >
            <i className="las la-cog"></i>
          </Button>

        </div>
      </div>

      <div style={isFleetCompact ? { width: "100%", maxWidth: "100%", overflowX: "hidden" } : undefined}>
        <div className={isFleetCompact ? "" : "row"}>
          <div
            className=""
            style={
              isFleetCompact
                ? {
                  width: "100%",
                  maxWidth: "100%",
                  overflowX: "auto",
                  overflowY: "hidden",
                  WebkitOverflowScrolling: "touch",
                }
                : undefined
            }
          >
            <Table className="dataTable">
              <thead className="bg-white text-uppercase">
                <tr className="ligth ligth-data">
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAllChecked}
                      onChange={(event) => handleSelectAllCheckboxChange(event.target.checked)}
                    />
                  </th>

                  {selectedColumns.immatriculation_vehicule && (
                    <th className="sorting" onClick={() => handleSortingColum("immatriculation_vehicule")}>
                      {translate("Vehicle")}
                    </th>
                  )}

                  {selectedColumns.psn_dispositif && (
                    <th className="sorting" onClick={() => handleSortingColum("psn_dispositif")}>
                      {translate("PSN")}
                    </th>
                  )}

                  {selectedColumns.nom_groupe && (
                    <th className="sorting" onClick={() => handleSortingColum("nom_groupe")}>
                      {translate("Vehicles Groups")}
                    </th>
                  )}

                  {selectedColumns.nom_user && (
                    <th className="sorting" onClick={() => handleSortingColum("nom_user")}>
                      {translate("User")}
                    </th>
                  )}

                  {selectedColumns.nom_conducteur && (
                    <th className="sorting" onClick={() => handleSortingColum("nom_conducteur")}>
                      {translate("Driver")}
                    </th>
                  )}

                  {selectedColumns.TIMESTAMP && (
                    <th className="sorting" onClick={() => handleSortingColum("TIMESTAMP")}>
                      {translate("Date Time")}
                    </th>
                  )}

                  {selectedColumns.GPSDIST && (
                    <th className="sorting" onClick={() => handleSortingColum("GPSDIST")}>
                      {translate("Distance")}
                    </th>
                  )}

                  {selectedColumns.GSMLVL && (
                    <th className="sorting" onClick={() => handleSortingColum("GSMLVL")}>
                      {translate("GSM")}
                    </th>
                  )}

                  {selectedColumns.SOG && (
                    <th className="sorting" onClick={() => handleSortingColum("SOG")}>
                      {translate("Speed")}
                    </th>
                  )}

                  <th>{translate("State")}</th>
                  <th>{translate("Actions")}</th>
                </tr>
              </thead>

              {loading ? (
                <tr>
                  <td colSpan={12}>
                    <div className="text-center">
                      <PropagateLoader color={"#123abc"} loading={loading} size={20} />
                    </div>
                  </td>
                </tr>
              ) : list_Fleet.length === 0 ? (
                <tr>
                  <td colSpan={12} className="text-center">
                    {translate("No vehicles available")}
                  </td>
                </tr>
              ) : (
                <>
                  {list_Fleet.map((item: any, index: number) => {
                    const rowId = `row_${index}`;
                    return (
                      <tbody key={item.id_vehicule} className="ligth-body">
                        <tr data-id={rowId}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedRows.has(index)}
                              onChange={(event) => handleCheckboxChange(index, event.target.checked)}
                            />
                          </td>

                          {selectedColumns.immatriculation_vehicule && (
                            <td>
                              <div className="d-flex align-items-center" onClick={() => handleRowClick(rowId, item.LAT, item.LON)}>
                                <button
                                  type="button"
                                  aria-label={translate(expandedRow === rowId ? "Close vehicle details" : "Open vehicle details")}
                                  aria-expanded={expandedRow === rowId}
                                  className="icon-chevron"
                                  style={{
                                    background: "transparent",
                                    border: 0,
                                    cursor: "pointer",
                                    marginRight: "10px",
                                    fontSize: "20px",
                                    padding: 0,
                                    color: "#667085",
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handleRowClick(rowId, item.LAT, item.LON);
                                  }}
                                >
                                  <i className={`las ${expandedRow === rowId ? "la-chevron-down" : "la-chevron-right"}`}></i>
                                </button>

                                <div>
                                  <span
                                    id={`vehicle-${item.id_vehicule}`}
                                    style={{
                                      cursor: "pointer",
                                      position: "relative",
                                      color: copiedId === item.id_vehicule.toString() ? "#28a745" : "#007bff",
                                    }}
                                    title={translate("Click to copy the registration matriculation")}
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      if (item.immatriculation_vehicule && item.id_vehicule.toString()) {
                                        copyToClipboard(item.immatriculation_vehicule, item.id_vehicule.toString());
                                      }
                                    }}
                                  >
                                    <>
                                      <span style={{ color: copiedId === item.id_vehicule.toString() ? "#28a745" : "#007bff" }}>
                                        {item.immatriculation_vehicule}
                                      </span>

                                      {copiedId === item.id_vehicule.toString() && (
                                        <span
                                          style={{
                                            position: "absolute",
                                            top: "-20px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            backgroundColor: "#28a745",
                                            color: "#fff",
                                            padding: "2px 5px",
                                            borderRadius: "4px",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {translate("Matriculation Copied")}
                                        </span>
                                      )}
                                    </>
                                  </span>

                                  <p className="mb-0">
                                    <small>{item.vehicule_type}</small>
                                  </p>
                                </div>
                              </div>
                            </td>
                          )}

                          {selectedColumns.psn_dispositif && <td>{item.psn_dispositif}</td>}
                          {selectedColumns.nom_groupe && <td>{item.nom_groupe}</td>}
                          {selectedColumns.nom_user && <td>{item.nom_user} {item.prenom_user} </td>}

                          {selectedColumns.nom_conducteur && (
                            <td>
                              {item.nom_conducteur && item.prenom_conducteur ? (
                                <>
                                  {item.IB_CODE && (
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 1000 }}
                                      overlay={<Tooltip id="tooltip">{item.IB_CODE}</Tooltip>}
                                    >
                                      <span style={{ color: "#007bff", cursor: "pointer", userSelect: "text", display: "inline-block" }}>
                                        {" "} {item.nom_conducteur} {item.prenom_conducteur}
                                      </span>
                                    </OverlayTrigger>
                                  )}
                                </>
                              ) : item.IB_CODE ? (
                                <span title={item.IB_CODE} style={{ color: "#007bff", cursor: "pointer", userSelect: "text" }}>
                                  {item.IB_CODE}
                                </span>
                              ) : (
                                ""
                              )}
                            </td>
                          )}

                          {selectedColumns.TIMESTAMP && <td>{toTimestamp(item.TIMESTAMP)}</td>}
                          {selectedColumns.GPSDIST && <td>{Math.floor(item.GPSDIST / 1000)} km</td>}

                          {selectedColumns.GSMLVL && (
                            <td>
                              {item.GSMLVL !== null ? item.GSMLVL.toFixed(0) : "0"}%{" "}
                              {item.GSMLVL !== null && (
                                <i
                                  style={{ color: BarreReseau(item.GSMLVL).split("color:")[1].slice(0, -1) }}
                                  className={`las la-signal ${BarreReseau(item.GSMLVL)}`}
                                ></i>
                              )}
                            </td>
                          )}

                          {selectedColumns.SOG && (
                            <td style={{ minWidth: "85px" }}>
                              {item.SOG !== null && (
                                <i
                                  style={{ color: BarreSpeed(item.SOG).split("color:")[1].slice(0, -1) }}
                                  className={`${BarreSpeed(item.SOG)}`}
                                >
                                  <span>{item.SOG.toFixed(0)} Km/h</span>
                                </i>
                              )}
                            </td>
                          )}

                          <td>
                            <i className={ValidatePosition(item.NST)}></i>
                            <img
                              src={engineStat(item.ENGINESTAT, item.SOG, translate).iconState}
                              alt=""
                              title={engineStat(item.ENGINESTAT, item.SOG, translate).tooltipMessage}
                            />
                          </td>

                          <td>
                            <i
                              className="fas fa-map-marker-alt btn-zoom"
                              onClick={() => handleMapIconClick(item.LAT, item.LON, item)}
                              style={{
                                cursor: "pointer",
                                margin: "5px",
                                fontSize: "20px",
                                color: "red",
                                textDecoration: "underline",
                              }}
                            ></i>

                            <Link
                              to={`/position-tracking/${formatDateInServerUtc(item.TIMESTAMP)}/${formatDateInServerUtc(item.TIMESTAMP)}/${item.immatriculation_vehicule}`}
                              className="btn btn-light btn-zoom"
                              data-toggle="tooltip"
                              data-placement="top"
                              title={translate("Details")}
                            >
                              <i className="fas fa-route" style={{ fontSize: "1.2em" }}></i>
                            </Link>
                          </td>
                        </tr>

                        {expandedRow === rowId && (
                          <tr>
                            <td colSpan={12}>
                              <div className="fleet-detail-panel">
                                <Table responsive className="fleet-detail-tabs">
                                  <thead>
                                    <tr>
                                      <td
                                        role="tab"
                                        aria-selected={selectedHeader === "additionalInfo"}
                                        style={{ cursor: "pointer", textAlign: "center" }}
                                        className={`h6 fleet-detail-tab ${selectedHeader === "additionalInfo" ? "table-active" : ""}`}
                                        onClick={() => setSelectedHeader("additionalInfo")}
                                      >
                                        {translate("Additional information")}
                                      </td>
                                      <td
                                        role="tab"
                                        aria-selected={selectedHeader === "gpsActivity"}
                                        style={{ cursor: "pointer", textAlign: "center" }}
                                        className={`h6 fleet-detail-tab ${selectedHeader === "gpsActivity" ? "table-active" : ""}`}
                                        onClick={() => setSelectedHeader("gpsActivity")}
                                      >
                                        {translate("GPS activity")}
                                      </td>
                                    </tr>
                                  </thead>
                                </Table>

                                <Table className="fleet-detail-content">
                                  <tbody>
                                    {selectedHeader === "additionalInfo" && (
                                      <>
                                        <tr>
                                          <td colSpan={12}>{translate("Vehicle")}:</td>
                                          <td colSpan={12}>{item.immatriculation_vehicule}</td>
                                        </tr>

                                        <tr>
                                          <td colSpan={12}>{translate("Vehicles Groups")}:</td>
                                          <td colSpan={12}>{item.nom_groupe}</td>
                                        </tr>

                                        <tr>
                                          <td colSpan={12}>{translate("Date Time")}:</td>
                                          <td colSpan={12}>{toTimestamp(item.TIMESTAMP)}</td>
                                        </tr>

                                        <tr>
                                          <td colSpan={12}>{translate("Speed")}:</td>
                                          <td colSpan={12}>{item.SOG} km/h</td>
                                        </tr>

                                        <tr>
                                          <td colSpan={12}>{translate("Address")}:</td>
                                          <td colSpan={12}>
                                            {loadingAddress ? "Loading address..." : address}
                                            <i
                                              className="las la-map-marker-alt"
                                              onClick={() => handleMapIconClick(item.LAT, item.LON, item)}
                                              style={{ cursor: "pointer", marginLeft: "10px" }}
                                            ></i>
                                          </td>
                                        </tr>
                                      </>
                                    )}

                                    {selectedHeader === "gpsActivity" && (
                                      <tr>
                                        <td colSpan={12}>
                                          <LineChartComponent psnDispositif={item.psn_dispositif} />
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    );
                  })}
                </>
              )}
            </Table>

            <MapDrawer
              show={showMapModal}
              onClose={() => setShowMapModal(false)}
              lat={markerCoordinates.LAT}
              lng={markerCoordinates.LON}
              vehicle={selectedVehicle}
            />
          </div>

          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <span>
                {translate("Displaying")} {list_Fleet.length} {translate("out of")} {total}
              </span>
            </div>

            <div className="col-md-6 d-flex justify-content-end">
              <ReactPaginate
                previousLabel={"previous"}
                nextLabel={"next"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
